import React from 'react';
import ReactMarkdown from 'react-markdown';
import { ExternalLink } from 'lucide-react';

const MarkdownRenderer = ({ children }) => {
  const components = {
    p: ({ children }) => <p className="mb-4">{children}</p>,
    ul: ({ children }) => <ul className="list-disc list-outside pl-6 mb-4 space-y-1">{children}</ul>,
    ol: ({ children }) => <ol className="list-decimal list-outside pl-6 mb-4 space-y-1" style={{ counterReset: 'item' }}>{children}</ol>,
    li: ({ children, ordered }) => {
      const className = ordered ? "pl-1.5" : "pl-1";
      return <li className={className}>{children}</li>;
    },
    a: ({ href, children }) => {
      const absoluteHref = href.startsWith('http://') || href.startsWith('https://')
        ? href
        : `https://${href}`;

      return (
        <a 
          href={absoluteHref} 
          className="text-blue-600 font-medium hover:text-blue-800 inline-flex items-center"
          target="_blank"
          rel="noopener noreferrer"
        >
          {children}
          <ExternalLink className="ml-1 h-4 w-4" />
        </a>
      );
    },
  };

  return (
    <div className="prose prose-blue max-w-none">
      <ReactMarkdown 
        components={components}
        className="markdown-content"
      >
        {children}
      </ReactMarkdown>
    </div>
  );
};

export default MarkdownRenderer;